import { render, staticRenderFns } from "./NuevaSolicitudSection.vue?vue&type=template&id=0cdcc57e&scoped=true"
import script from "./NuevaSolicitudSection.vue?vue&type=script&lang=js"
export * from "./NuevaSolicitudSection.vue?vue&type=script&lang=js"
import style0 from "./NuevaSolicitudSection.vue?vue&type=style&index=0&id=0cdcc57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdcc57e",
  null
  
)

export default component.exports